import PropTypes from 'prop-types';
import React from 'react';
import { globalUI } from '../../core';
import { connect } from 'react-redux';
import { divShadow } from './styles';
const CtrlHeader = (
    sessionId
) => {
    let visibleProp = (sessionId && sessionId.sessionId!==null) === true ? 'none': 'flex'
    return (
        <div style={ divShadow }>        
            <div className="row" >
                <div style={{display : visibleProp }}>
                    <div className="col-sm-2">
                        <img style={{ height: "60px", padding: "5px 5px 5px 5px" }} src={globalUI.getImage(`./${"Ruskin_Logo"}.png`)}></img>
                    </div>
                    <div className="col-sm-2">
                    </div>
                </div>                
            </div>           
        </div>
    );
};

CtrlHeader.propTypes = {
    sessionId: PropTypes.string
};
CtrlHeader.defaultProps = {
    sessionId: null
};
const mapStateToProps = ({ user }) => ({
    sessionId: user.sid
});
export default connect(mapStateToProps) (CtrlHeader);